import React, { memo } from 'react';
import './StorySettingsForm.css';

/**
 * StorySettingsForm component
 * Form for setting story theme and desired ending
 *
 * @param {Object} props - Component props
 * @param {string} props.theme - Current theme value
 * @param {string} props.desiredEnding - Current desired ending value
 * @param {Function} props.onThemeChange - Callback for theme changes
 * @param {Function} props.onEndingChange - Callback for ending changes
 */
const StorySettingsForm = memo(({
  theme = '',
  desiredEnding = '',
  onThemeChange,
  onEndingChange
}) => {
  // Handler for theme input changes
  const handleThemeChange = (e) => {
    if (onThemeChange) {
      onThemeChange(e.target.value);
    }
  };

  // Handler for desired ending input changes
  const handleEndingChange = (e) => {
    if (onEndingChange) {
      onEndingChange(e.target.value);
    }
  };

  return (
    <div className="story-settings-form">
      <div className="story-settings-form__field">
        <label className="story-settings-form__label" htmlFor="story-theme">
          Theme
        </label>
        <input
          id="story-theme"
          type="text"
          value={theme}
          onChange={handleThemeChange}
          placeholder="e.g., Adventure in a magical forest"
          className="story-settings-form__input"
        />
        {/* Hint text removed */}
      </div>
      
      <div className="story-settings-form__field">
        <label className="story-settings-form__label" htmlFor="story-ending">
          Desired Ending
        </label>
        <input
          id="story-ending"
          type="text"
          value={desiredEnding}
          onChange={handleEndingChange}
          placeholder="e.g., Characters find the hidden treasure"
          className="story-settings-form__input"
        />
        {/* Hint text removed */}
      </div>
    </div>
  );
});

StorySettingsForm.displayName = 'StorySettingsForm';

export default StorySettingsForm;